(function(){
    angular
        .module('app')
        .directive('ngSlugify', slugifyF);

        slugifyF.$inject = ['$timeout'];
        function slugifyF($timeout){
            return {
            require: 'ngModel',
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                    var value = $attrs.value;
                    var $element = $(element);
                    var name = $element.attr("id");
                    var valuesArray = [];
                    var valorDentro = true;
                    //console.log("slug");

                    $.fn.selectRange = function(start, end) {
                    if(end === undefined) {
                        end = start;
                    }
                    return this.each(function() {
                            if('selectionStart' in this) {
                                this.selectionStart = start;
                                this.selectionEnd = end;
                            } else if(this.setSelectionRange) {
                                this.setSelectionRange(start, end);
                            } else if(this.createTextRange) {
                                var range = this.createTextRange();
                                range.collapse(true);
                                range.moveEnd('character', end);
                                range.moveStart('character', start);
                                range.select();
                            }
                        });
                    };

                    $element.on('keyup', function(e) {
                        ////console.log($element.val());
                        //console.log("keyup");
                        var posicionInput = e.target.selectionEnd;
                        var valor = $element.val();
                        $element.val(valor.toLowerCase().replace(/á/g,"a").replace(/é/g,"e").replace(/í/g,"i").replace(/ó/g,"o").replace(/ú/g,"u").replace(/à/g,"a").replace(/è/g,"e").replace(/ò/g,"o").replace(/ì/g,"i").replace(/ù/g,"u").replace(/ü/g,"u").replace(/ /g,'-').replace(/[^a-z0-9-]/g,function(a,e,i){
                           if(!e && a==':')
                                   return ':';
                               posicionInput--;
                           return '';
                        }));
                        $element.selectRange(posicionInput);
                    });

                    if($attrs.fieldslug!=''){
                        $elementField = $('#'+$attrs.fieldslug);
                        console.log("entrando");
                        $elementField.on('keyup', function(e) {
                            //console.log("entrandokeyup");
                            ////console.log($element.val());
                            //console.log("keyup");
                            if(valorDentro){
                                var posicionInput = e.target.selectionEnd;
                                var valor = $(this).val();
                                console.log(valor);
                                $element.val(valor.toLowerCase().replace(/á/g,"a").replace(/é/g,"e").replace(/í/g,"i").replace(/ó/g,"o").replace(/ú/g,"u").replace(/à/g,"a").replace(/è/g,"e").replace(/ò/g,"o").replace(/ì/g,"i").replace(/ù/g,"u").replace(/ü/g,"u").replace(/ /g,'-').replace(/[^a-z0-9-]/g,function(a,e,i){
                                   if(!e && a==':')
                                           return ':';
                                       posicionInput--;
                                   return '';
                                })).trigger("change");
                                $element.selectRange(posicionInput);
                            }
                        });

                        $elementField.on('focus', function(e) {
                            var valorfoc = $element.val();
                            if(valorfoc.trim()!=""){
                                valorDentro = false;
                            }else{
                                valorDentro = true;
                            }
                        });
                    }
                });
            }
          }
      }
})();